import Grid2 from "@mui/material/Grid2";

import { useQuery } from "@tanstack/react-query";
import { SpareCarrier } from "../../models/SpareCarrier";
import { getReadyCarriers } from "../../repositories/SparesRepository";
import { TableSpare } from "./components/TableSpare";

type useReadyCarriersProps = {
	onError: (error: Error) => void;
	campaignId: number;
	isNextCampaign?: boolean;
	onSuccess?: (data: any[]) => void;
};

export const useReadyCarriers = ({
	campaignId,
	isNextCampaign,
	onError,
}: useReadyCarriersProps) => {
	return useQuery<SpareCarrier[], Error>({
		queryKey: ["readyCarriers", campaignId, isNextCampaign],
		queryFn: ({ signal }) =>
			getReadyCarriers({ campaignId, isNextCampaign }, signal),
		onError: onError,
		refetchInterval: 60000, // miliseconds
	});
};

export const SparePage = () => {
	return (
		<>
			<Grid2 container justifyContent="center" alignItems="center">
				<Grid2 size={{ md: 12, xs: 12 }} style={{ margin: 0 }}>
					<TableSpare />
				</Grid2>
			</Grid2>
		</>
	);
};
